import { template } from 'lodash';

class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/info/boxes'
			},
			messagestate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/message/stats'
			},

			chatHourly: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chat/hourly'
			},
			chatbotInfo: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/customer/campaign'
			},
			shellTerritory: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/fetch/shell/territories'
			},
			templateReports: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/report'
			},
			callSummaryChart: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/calls/summary'
			},
			sessionEnds: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reports/session-ends'
			},
			//ticket count api
			ticketCounts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/count'
			},
		};
	}
}

export default new APIS();
